module.exports = __webpack_public_path__ + "img/climate_actions_nature.113516a.jpg";